export function getWindowWidth (state) {
    return state.windowWidth;
}

export function getBreakpoints (state) {
    return state.breakpoints;
}

export function getActiveBreakpoints (state) {
    return state.activeBreakpoints;
}

export function getHeaderHeight (state) {
    return state.headerHeight;
}

export function getActiveFlyout (state) {
    return state.activeFlyout;
}

export function getBrowser (state) {
    return state.browser;
}

export function getSearchQuery (state) {
    return state.searchQuery;
}

export function areSearchResultsVisible (state) {
    return state.searchBarVisible && !state.searchLoading && state.searchQuery && state.searchResultsActive;
}

export function areSearchSuggestionsVisible (state) {
    return state.searchBarVisible && !state.searchSuggestionsLoading && state.searchSuggestionsCurrentlyVisible && state.searchSuggestionsActive;
}

export function isDesktopNavigation (state) {
    return state.windowWidth >= 980;
}

export function isMobileNavigation (state, getters) {
    return !getters.isDesktopNavigation;
}
